import { render, staticRenderFns } from "./HomeForEmployees.vue?vue&type=template&id=2c18a895&scoped=true&"
import script from "./HomeForEmployees.vue?vue&type=script&lang=js&"
export * from "./HomeForEmployees.vue?vue&type=script&lang=js&"
import style0 from "./HomeForEmployees.vue?vue&type=style&index=0&id=2c18a895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18a895",
  null
  
)

export default component.exports